import { Suspense } from 'react';

import { lazyRetry } from '@cast/utils';

import { SuspenseLoader } from 'components/loaders';

const SplitMeBudgetsController = lazyRetry(
  () => import('@cast/split-me/pages/budgets/BudgetsController')
);

export const BudgetsController = () => (
  <Suspense fallback={<SuspenseLoader />}>
    <SplitMeBudgetsController />
  </Suspense>
);
